export const DefaultOutputDatum = 'ITRF2014'
